import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {
  IconButton,
  Stack,
  Tab,
  Tabs,
  Tooltip,
} from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import SidePanel from 'FRONTEND/components/SidePanel';
import i18n from 'FRONTEND/utils/i18n';
import { isSpecialKey } from 'LEGACY/compatibility';

const isCurrentTab = (tab) => {
  const currentUrl = window.location.pathname;
  return currentUrl.endsWith(tab.href) ||
    currentUrl.replace('/update', '').endsWith(tab.href) ||
    (currentUrl.includes('consultation') && tab.href && tab.href.includes('history'));
};

const PatientSidePanel = ({
  children,
  links,
}) => {
  const isExtended = useSelector((state) => state.sidePanel.isExtended);
  // Remove empty links.
  links = links.filter(link => link.href);

  // Tab Management
  const [currentTabIndex, setCurrentTabIndex] = useState(links.findIndex(isCurrentTab) !== -1 ? links.findIndex(isCurrentTab) : 0);
  const handleTabClick = (event, newTabIndex, isNewPage) => {
    if (isSpecialKey(event)) {
      return;
    }
    if (isNewPage) {
      event.target.setAttribute('target', '_blank');
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    setCurrentTabIndex(newTabIndex);
  };
  const handleTabOpenInNewPageClick = (event, href) => {
    event.preventDefault();
    window.open(href, '_blank').focus();
    event.stopPropagation();
  };

  return (
    <SidePanel>
      {children}
      <Tabs
        TabIndicatorProps={{
          sx: {
            width: (theme) => theme.spacing(1),
          },
        }}
        orientation='vertical'
        value={currentTabIndex}
        sx={{
          marginTop: '40px',
          width: '100%',
        }}
      >
        {links.map(({ label, icon, href }, index) => (
          href &&
            <Tab
              key={index}
              iconPosition='start'
              component='a'
              label={isExtended && (
                <Stack width='100%' justifyContent='space-between' alignItems='center' direction='row'>
                  {label}
                  <Tooltip title={i18n._('Open in new tab')}>
                    <IconButton
                      edge='end'
                      onClick={(event) => handleTabOpenInNewPageClick(event, href)}
                      sx={{ opacity: 0, padding: '6px' }}
                      size='large'
                    >
                      <OpenInNewIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>
              )}
              href={href}
              data-pjax
              icon={icon}
              onClick={(event) => handleTabClick(event, index)}
              sx={{
                maxHeight: '45px',
                '&:hover, &:focus': {
                  '& .MuiIconButton-edgeEnd': {
                    opacity: 1,
                  },
                },
              }}
            />
        ))}
      </Tabs>
    </SidePanel>
  );
};

export default PatientSidePanel;
